export enum ImportContactStatus {
  PENDING = "pending",
  PROCESSING = "processing",
  SUCCESS = "success",
  ERROR = "error",
  DUPLICATE = "duplicate",
}

export interface ImportContact {
  email: string;
  role: string;
  status: ImportContactStatus;
  errorMessage?: string;
}

export enum ImportPhase {
  UPLOAD = "upload",
  PREVIEW = "preview",
  IMPORTING = "importing",
  COMPLETED = "completed",
}
